import React, { Suspense } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { SnackbarOrigin, SnackbarProvider } from 'notistack';

import { CssBaseline } from '@material-ui/core';
import Init from '../Init';
import Loading from 'shared/ui/Loading';
import NewComment from 'components/Notifications/NewComment';
import NewMessage from 'components/Notifications/NewMessage';
import { ThemeProvider } from '@material-ui/styles';
import { WebsocketProvider } from 'hooks/useWebsocket';
import { pdfjs } from 'react-pdf';
import { useAppSelector } from 'hooks/hooks';
import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const notistackConfig: SnackbarOrigin = {
  horizontal: 'right',
  vertical: 'bottom',
};

const App: React.FunctionComponent = () => {
  const theme = useAppSelector((state) => state.theme.theme);

  useEffect(() => {
    const { sessionStorage } = window;
    if (!sessionStorage.getItem('tabid')) sessionStorage.setItem('tabid', uuidv4());
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <WebsocketProvider>
        <CssBaseline />
        <Router basename="/">
          <SnackbarProvider
            maxSnack={4}
            anchorOrigin={notistackConfig}
            Components={{
              info: NewMessage,
              warning: NewComment,
            }}
          >
            <Switch>
              <Suspense fallback={<Loading />}>
                <Route path="/" component={Init} />
              </Suspense>
            </Switch>
          </SnackbarProvider>
        </Router>
      </WebsocketProvider>
    </ThemeProvider>
  );
};

export default App;
